/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { CredentialProof } from './CredentialProof';
import { CredentialProofs } from './CredentialProofs';

export const Credential11Proof: core.serialization.Schema<
    serializers.Credential11Proof.Raw,
    Truvity.Credential11Proof
> = core.serialization.undiscriminatedUnion([CredentialProof, CredentialProofs]);

export declare namespace Credential11Proof {
    export type Raw = CredentialProof.Raw | CredentialProofs.Raw;
}
